import './App.css';
import Footer from './components/Footer';
import Home from './components/Home';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import About from './components/About';
import Energy from './components/Energy';
import Dropdown from './components/Dropdown';
import { useState } from 'react';
import EnergyStorage from './components/EnergyStorage';
import ContactUs from './components/Pages/ContactUs';
import Funding from './components/Pages/Funding';
import { FaRegFrownOpen } from 'react-icons/fa';
import Environment from './components/Pages/Environment';

function App() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Router>
      <Navbar className='navbar' toggle={toggle} />
      <div className={isOpen ? 'dropMenu' : 'dropMenu hidden'}>
        <Dropdown />
      </div>

      <div className='container mx-auto mainPage'>
        <Switch>
          <Route path='/' exact>
            <Home />
          </Route>

          <Route path='/about'>
            <About />
          </Route>

          <Route path='/energy-efficiency'>
            <Energy />
          </Route>

          <Route path='/energy-storage'>
            <EnergyStorage />
          </Route>

          <Route path='/funding'>
            <Funding />
          </Route>

          <Route path='/environment'>
            <Environment />
          </Route>

          <Route path='/contact'>
            <ContactUs />
          </Route>

          <Route path='*'>
            <h1 className='text-5xl mt-20  text-center'>שגיאה מספר 404 ; העמוד הזה לא קיים, כנראה שחלה טעות בכתובת </h1>
            <FaRegFrownOpen className='text-9xl m-auto my-20' />
            <div className='text-5xl text-center underline'>
              <Link to='/'>חזור הביתה</Link>
            </div>
          </Route>
        </Switch>
      </div>
      <Footer className='footer allo' />
    </Router>
  );
}

export default App;
